import React, { createContext, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { normalizePublicPath } from '../../services/publicSite';
import english from './landingEnglish.json';

type Language = 'ro' | 'en';
const storageKey = 'orarivo-landing-language';
const translations: Record<string, string> = english;
const LandingLanguageContext = createContext({
  language: 'ro' as Language, locale: 'ro-RO',
  setLanguage: (_language: Language) => {},
  t: (text: string) => text,
});
export const LandingLanguageProvider = ({ children }: { children: React.ReactNode }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  // Each language has a stable, crawlable URL. Account and legal pages stay Romanian.
  const language: Language = normalizePublicPath(pathname) === '/en' ? 'en' : 'ro';
  const setLanguage = (value: Language) => {
    navigate(value === 'en' ? '/en/' : '/');
    try { localStorage.setItem(storageKey, value); } catch { /* Switching still works without storage. */ }
  };
  return <LandingLanguageContext.Provider value={{ language, locale: language === 'en' ? 'en-GB' : 'ro-RO', setLanguage, t: text => language === 'en' ? translations[text] || text : text }}>{children}</LandingLanguageContext.Provider>;
};
export const useLandingLanguage = () => useContext(LandingLanguageContext);
